<template>
  <drawings
    :is-mounted="isMounted"
    :plain-view="false"
    :run="run"
    :part="[]"
    :outlets="outlets"
    class="w-full pt-4"
  />
</template>

<script>
import Drawings from './../Drawings/Index'

export default {
  components: {
    Drawings,
  },
  props: {
    run     : Object,
    outlets : Object,
  },
  remember: 'form',
  data() {
    return {
      isMounted: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true
    }, 150)
  },
}
</script>
<style>
body {
  background: #fff;
  height: 100%;
}
</style>
